export const reportMetricIds = [
    "spend",
    "impressions",
    "clicks",
    "uniqueClicks",
    "outboundClicks",
    "purchases",
    "revenue",
    "addToCart",
    "ctr",
    "outboundCtr",
    "cpc",
    "cpm",
    "cpa",
    "roas",
    "aov",
    "cvr",
    "hookRate",
    "holdRate",
];
export const metricIds = [
    ...reportMetricIds,
    "reach",
    "frequency",
];
const definitions = [
    metric("spend", "Spend", "spend", "currency"),
    metric("impressions", "Impressions", "impressions", "integer"),
    metric("clicks", "Clicks", "clicks", "integer"),
    metric("uniqueClicks", "Unique clicks", "unique_clicks", "integer"),
    metric("outboundClicks", "Outbound clicks", "outbound_clicks", "integer"),
    metric("purchases", "Purchases", "purchases", "integer"),
    metric("revenue", "Revenue", "action_values_purchases", "currency"),
    metric("addToCart", "Add to cart", "add_to_cart", "integer"),
    ratio("ctr", "CTR", "clicks", "impressions", "percent"),
    ratio("outboundCtr", "Outbound CTR", "outbound_clicks", "impressions", "percent"),
    ratio("cpc", "CPC", "spend", "outbound_clicks", "currency"),
    ratio("cpm", "CPM", "spend * 1000", "impressions", "currency"),
    ratio("cpa", "CPA", "spend", "purchases", "currency"),
    ratio("roas", "ROAS", "action_values_purchases", "spend", "decimal"),
    ratio("aov", "AOV", "action_values_purchases", "purchases", "currency"),
    {
        ...ratio("cvr", "CVR", "purchases", "outbound_clicks", "percent"),
        tooltip: "Purchases ÷ outbound clicks.",
    },
    {
        ...ratio("hookRate", "Hook", "video_3sec_views", "video_observed_impressions", "percent"),
        tooltip: "3-second video views ÷ impressions with observed video metrics.",
    },
    {
        ...ratio("holdRate", "Hold", "video_thruplay_watched_actions", "video_3sec_views", "percent"),
        tooltip: "ThruPlays ÷ 3-second views. Meta counts a ThruPlay at 15 continuous seconds watched, or full completion for videos shorter than 15s.",
    },
    metric("reach", "Reach", "reach", "integer", false),
    ratio("frequency", "Frequency", "impressions", "reach", "decimal", false),
];
function metric(id, label, numeratorSql, format, summable = true) {
    return { format, id, label, numeratorSql, summable };
}
function ratio(id, label, numeratorSql, denominatorSql, format, summable = true) {
    return {
        denominatorSql,
        format,
        id,
        label,
        numeratorSql,
        summable,
    };
}
export const MetricRegistry = Object.freeze(Object.fromEntries(definitions.map((definition) => [definition.id, Object.freeze(definition)])));
export class MetricRegistryError extends Error {
    statusCode = 400;
    constructor(message) {
        super(message);
        this.name = "MetricRegistryError";
    }
}
export function getMetric(id) {
    if (!Object.hasOwn(MetricRegistry, id)) {
        throw new MetricRegistryError(`Unknown metric or sort id "${id}"`);
    }
    return MetricRegistry[id];
}
export function metricSql(id, grain) {
    const definition = getMetric(id);
    if (!definition.summable && grain !== "single-ad-day") {
        throw new MetricRegistryError(`Metric "${definition.id}" is available only for one ad on one day`);
    }
    const aggregate = definition.denominatorSql === undefined
        ? `IFNULL(SUM(${definition.numeratorSql}), 0)`
        : `SAFE_DIVIDE(SUM(${definition.numeratorSql}), SUM(${definition.denominatorSql}))`;
    return `CAST(${aggregate} AS FLOAT64)`;
}
//# sourceMappingURL=metrics.js.map